module.exports = __webpack_public_path__ + "static/media/SmartShop_5-217w.ceda0d5e.png";